export const newsTypeOptions = [
  { label: '商业项目', value: 'biz' },
  { label: '资讯中心', value: 'news' },
  { label: '成功案例', value: 'cases' },
]

export const categoryOptions = [
  { label: '全部', value: 'all' },
  { label: '投资移民', value: 'invest' },
  { label: '商业投资工作签证', value: 'business' },
  { label: '技术移民——6分制', value: 'tech' },
  { label: '父母退休移民', value: 'parent' },
  { label: '配偶团聚移民', value: 'spouse' },
  { label: '父母团聚移民', value: 'parents' },
  { label: '工作签证', value: 'work' },
  { label: '留学', value: 'study' },
  { label: '父母超级签证', value: 'super' },
]

const baseConditions = [
  { title: '', content: '主申请人年满18周岁，身体健康，无重大违法记录。', items: [] },
  { title: '', content: '按照项目要求提供学历、工作、资产或家庭关系等证明材料。', items: [] },
  { title: '', content: '申请材料需真实完整，并配合移民局补件与后续节点操作。', items: [] },
]

const baseProcess = [
  '免费咨询，确认项目方向',
  '签约并建立客户档案',
  '准备基础材料并完成资格预审',
  '顾问审核后递交官方申请',
  '补件、调查与获批后续服务',
]

const baseDocuments = [
  { name: '申请人正面照片', desc: '近期彩色照片，尺寸符合官方要求。' },
  { name: '旅行证件影印本', desc: '包含个人信息页、签发页与有效签证页。' },
  { name: '学历及工作证明', desc: '学历证书、成绩单、在职证明及相关工作文件。' },
]

const projectSeeds = [
  { id: 1, name: '新西兰投资移民', period: '3-6个月', amount: '500/1000万纽币，约￥2150/4300万人民币(汇率1：4.3)', english: '无', age: '无', identity: '全家一步到位居留身份', intro: '无英文，无经商要求，无需经营生意，只需投资就能全家一步到位获得新西兰居民签证。', isFeatured: true },
  { id: 2, name: '商业投资工作签证', period: '3-6个月', amount: '100/200万纽币', english: '雅思5分或同等级别', age: '无', identity: '工作签证→居留身份', intro: '适合希望先落地经营再规划身份的企业家。', isFeatured: true },
  { id: 3, name: '技术移民——6分制', period: '3-6个月', amount: '无', english: '雅思6.5分或同等级别', age: '无', identity: '居留身份', intro: '围绕职业、学历与语言能力的稳定路径。', isFeatured: true },
  { id: 4, name: '技术移民——绿名单', period: '3-5个月', amount: '无', english: '根据岗位要求评估', age: '无', identity: '居留身份', intro: '面向绿名单紧缺岗位的快速规划通道。', isFeatured: false },
  { id: 5, name: '父母退休移民', period: '4-7个月', amount: '100万纽币', english: '无', age: '无', identity: '居留身份', intro: '适合希望陪伴子女并长期定居新西兰的家庭。', isFeatured: true },
  { id: 6, name: '配偶团聚移民', period: '4-7个月', amount: '无', english: '无', age: '无', identity: '居留身份', intro: '围绕真实稳定关系准备团聚申请。', isFeatured: true },
  { id: 7, name: '未成年子女团聚移民', period: '2-4个月', amount: '无', english: '无', age: '24周岁及以下', identity: '居留身份', intro: '帮助未成年子女完成身份衔接与在读安排。', isFeatured: false },
  { id: 8, name: '父母团聚移民', period: '3-6个月', amount: '无', english: '无', age: '无', identity: '居留身份', intro: '适用于符合配额与担保条件的家庭团聚申请。', isFeatured: false },
  { id: 9, name: '工作签证', period: '3-7周', amount: '无', english: '高技能职位可灵活评估', age: '无', identity: '工作签证', intro: '聚焦雇主担保、岗位匹配和下签时效。', isFeatured: false },
  { id: 10, name: '留学', period: '1-5周', amount: '学费15-30万人民币/年', english: '本科雅思6分起', age: '无', identity: '学生签证', intro: '围绕学校录取、签证递交和后续规划联动。', isFeatured: false },
  { id: 11, name: '父母超级签证', period: '4个月左右', amount: '无', english: '无', age: '无', identity: '长期探访签证', intro: '适合家属长期探访与阶段性陪伴安排。', isFeatured: false },
]

const projectAdvantages = {
  1: [
    { type: 'text', text: '新西兰是所有发达国家中唯一没有资本增值税、没有房产买卖印花税和契税的国家，是真正的投资天堂；' },
    { type: 'text', text: '无学历、语言、工作经验等背景要求；' },
    { type: 'text', text: '一人申请，配偶和24周岁及以下经济不独立子女可随同移居新西兰；' },
    { type: 'group', title: '居住时间短', items: ['投资500万纽币的投资期为3年。', '投资1000万纽币的投资期为5年。'] },
    { type: 'text', text: '子女享受免费公立中小学教育，大学按照本地生收费；' },
    { type: 'text', text: '享受新西兰免费公费医疗服务；' },
    { type: 'text', text: '有购买新西兰房产、农场等资格。' },
  ],
  2: [
    { type: 'text', text: '先获工作签证，生意经营满足条件后申请居留身份，风险可控；' },
    { type: 'text', text: '对申请人无学历、英语硬性要求；' },
    { type: 'text', text: '投资金额相对投资移民更低；' },
    { type: 'text', text: '可携带配偶和子女，子女享受免费公立教育；' },
    { type: 'text', text: '获得工作签证后可享受新西兰医疗福利。' },
  ],
  3: [
    { type: 'text', text: '取消高额投资门槛，无需大额资金投入；' },
    { type: 'text', text: '采用6分制评分，更灵活地评估申请人的综合能力；' },
    { type: 'text', text: '审理速度快，一般3-6个月可获得结果；' },
    { type: 'text', text: '获得居留身份后享受新西兰完整福利；' },
    { type: 'text', text: '一人申请，全家移民。' },
  ],
}

export const projectList = projectSeeds.map((item) => ({
  ...item,
  overview: [
    item.id === 1
      ? '2025年4月1日，新西兰积极投资者+签证（Active Investor plus Visa）正式实施。申请人通过投资500/1000万纽币到新西兰债券、上市股票、新住宅物业开发、新建/改建商业或工业物业、慈善事业、指定管理基金等，一步到位获得全家居留身份。'
      : `${item.name} 面向不同背景的申请人，源盛团队会围绕资格评估、材料准备、政策风险和落地安排制定完整方案。`,
    '服务覆盖资格预审、材料整理、递交流程管理以及登陆后的安家衔接，帮助申请人以更稳妥的方式完成新西兰签证与移民规划。',
  ],
  advantages: projectAdvantages[item.id] || [
    { type: 'text', text: '政策稳定，路径清晰；' },
    { type: 'text', text: '源盛团队全程跟进，从评估到落地一站式服务；' },
    { type: 'text', text: '多年实战经验，疑难案例有突破口。' },
  ],
  conditions: item.id === 1 ? [
    { title: '投资额', content: '', items: [
      '直接型投资类别：投资额为500万纽币，约2150万人民币（汇率1:4.3计算），投资期为3年。直接投资包括新西兰企业、管理基金。',
      '平衡型投资类别：投资额为1000万纽币，约4300万人民币（汇率1:4.3计算），投资期为5年。投资类型（包括政府债券、地方债券、在纽交所交易的股票）、上市股票、新住宅物业开发、新建/改建商业或工业物业、慈善事业、指定管理基金。',
    ]},
    { title: '资产要求', content: '申请人的指定投资资金（nominated funds）或资产至少达到对应投资额，申请人必须证明投资资金合法所得。' },
    { title: '身体健康', content: '无传染性疾病或新西兰医疗系统负担高额费用的慢性疾病。部分不符合要求的情况，需要满足医疗豁免条件，严重疾病类（如慢性肾透析等），乙肝（要看HBV DNA数值）。' },
    { title: '无犯罪记录', content: '所有17周岁以上申请人或在过去10年里居住过的所有国家无犯罪记录，对于部分有犯罪记录的申请人，可以申请品行豁免。' },
  ] : [...baseConditions],
  process: baseProcess.map((title, index) => ({ step: index + 1, title })),
  processSteps: baseProcess.map((title, index) => ({ step: index + 1, title })),
  documents: baseDocuments.map((doc) => ({ ...doc })),
}))

export function getProjectById(id) {
  const targetId = Number(id)
  return projectList.find((item) => item.id === targetId) || null
}

export function buildProjectDetailPath(id) {
  return `/project-detail/${id}`
}

function buildNewsItem({
  id,
  type,
  category,
  tag,
  title,
  desc,
  date,
  cover,
  viewCount,
  isHomePreview = false,
}) {
  return {
    id,
    type,
    category,
    tag,
    title,
    desc,
    date,
    cover,
    viewCount,
    isHomePreview,
    subheading: `${tag} 申请重点`,
    content: [
      `${title} 围绕 ${tag} 的最新动态展开，结合近期新西兰政策与审理节奏进行了系统说明。`,
      `${desc} 源盛顾问团队会结合真实申请案例，帮助申请人理解材料准备、资格评估和递交节奏的核心差异。`,
      `如果您正在关注 ${tag}，建议尽早完成资格预审与时间规划，以便更从容地应对新西兰签证与移民申请中的关键节点。`,
    ],
  }
}

export const newsList = [
  buildNewsItem({
    id: 1,
    type: 'biz',
    category: 'business',
    tag: '商业投资工作签证',
    title: '新西兰幼儿园创业移民项目说明会',
    desc: '聚焦行业模型、岗位安排与新西兰落地经营准备。',
    date: '2026-04-28',
    cover: require('@/assets/imgs/ysgj_042@2x.png'),
    viewCount: 615,
  }),
  buildNewsItem({
    id: 2,
    type: 'biz',
    category: 'invest',
    tag: '投资移民',
    title: '新西兰精品酒店投资项目闭门分享',
    desc: '围绕投资结构、资产证明与新西兰后续经营安排展开。',
    date: '2026-04-27',
    cover: require('@/assets/imgs/ysgj_003@2x.png'),
    viewCount: 488,
    isHomePreview: true,
  }),
  buildNewsItem({
    id: 3,
    type: 'biz',
    category: 'tech',
    tag: '技术移民——6分制',
    title: '新西兰技术岗位雇主匹配与工签衔接方案说明',
    desc: '从岗位匹配到工签衔接，系统拆解新西兰申请节奏。',
    date: '2026-04-26',
    cover: require('@/assets/imgs/ysgj_004@2x.png'),
    viewCount: 372,
  }),
  buildNewsItem({
    id: 4,
    type: 'biz',
    category: 'super',
    tag: '父母超级签证',
    title: '新西兰父母超级签证长期探访规划答疑会',
    desc: '梳理新西兰家属长期探访的材料重点与停留安排。',
    date: '2026-04-25',
    cover: require('@/assets/imgs/ysgj_038@2x.png'),
    viewCount: 426,
  }),
  buildNewsItem({
    id: 5,
    type: 'biz',
    category: 'business',
    tag: '商业投资工作签证',
    title: '新西兰商业投资工作签证创业路径专场',
    desc: '围绕创业路径、岗位配置与新西兰实操节奏进行讲解。',
    date: '2026-04-24',
    cover: require('@/assets/imgs/ysgj_042@2x.png'),
    viewCount: 391,
  }),
  buildNewsItem({
    id: 6,
    type: 'news',
    category: 'tech',
    tag: '技术移民——6分制',
    title: '新西兰政策更新：技能签证评分说明',
    desc: '围绕评分规则与适用职业的新一轮新西兰内容更新。',
    date: '2026-04-23',
    cover: require('@/assets/imgs/ysgj_003@2x.png'),
    viewCount: 1568,
    isHomePreview: true,
  }),
  buildNewsItem({
    id: 7,
    type: 'news',
    category: 'work',
    tag: '工作签证',
    title: '新西兰工作签证材料准备要点全解析',
    desc: '结合雇主担保和材料要求逐项说明新西兰递交重点。',
    date: '2026-04-22',
    cover: require('@/assets/imgs/ysgj_004@2x.png'),
    viewCount: 924,
  }),
  buildNewsItem({
    id: 8,
    type: 'news',
    category: 'study',
    tag: '留学',
    title: '新西兰留学签证审理周期与财力证明新提醒',
    desc: '整理近期新西兰签证审理趋势和财力材料注意事项。',
    date: '2026-04-21',
    cover: require('@/assets/imgs/ysgj_038@2x.png'),
    viewCount: 638,
  }),
  buildNewsItem({
    id: 9,
    type: 'news',
    category: 'parent',
    tag: '父母退休移民',
    title: '源盛国际客户答谢会活动回顾',
    desc: '双城团队与客户现场交流新西兰身份规划与落地服务安排。',
    date: '2026-04-20',
    cover: require('@/assets/imgs/ysgj_042@2x.png'),
    viewCount: 428,
  }),
  buildNewsItem({
    id: 10,
    type: 'news',
    category: 'super',
    tag: '父母超级签证',
    title: '新西兰父母超级签证申请趋势观察',
    desc: '结合近期咨询案例，梳理新西兰父母长期探访方案变化。',
    date: '2026-04-19',
    cover: require('@/assets/imgs/ysgj_003@2x.png'),
    viewCount: 563,
  }),
  buildNewsItem({
    id: 11,
    type: 'cases',
    category: 'parent',
    tag: '父母退休移民',
    title: '捷报！客户无补件获批父母退休移民',
    desc: '适合作为新西兰父母退休移民案例区与相关推荐素材。',
    date: '2026-04-18',
    cover: require('@/assets/imgs/ysgj_004@2x.png'),
    viewCount: 932,
    isHomePreview: true,
  }),
  buildNewsItem({
    id: 12,
    type: 'cases',
    category: 'spouse',
    tag: '配偶团聚移民',
    title: '捷报！杭州Z女士配偶团聚签证顺利获批',
    desc: '补件阶段由顾问团队协助闭环，新西兰申请节奏稳定。',
    date: '2026-04-17',
    cover: require('@/assets/imgs/ysgj_038@2x.png'),
    viewCount: 681,
  }),
  buildNewsItem({
    id: 13,
    type: 'cases',
    category: 'work',
    tag: '工作签证',
    title: '捷报！深圳客户工作签证快速下签',
    desc: '岗位说明、雇主文件与新西兰材料逻辑一次性闭环。',
    date: '2026-04-16',
    cover: require('@/assets/imgs/ysgj_042@2x.png'),
    viewCount: 544,
  }),
  buildNewsItem({
    id: 14,
    type: 'cases',
    category: 'parents',
    tag: '父母团聚移民',
    title: '捷报！福州客户父母团聚顺利通过',
    desc: '关系证明与收入文件完整提交，新西兰审批过程顺畅。',
    date: '2026-04-15',
    cover: require('@/assets/imgs/ysgj_003@2x.png'),
    viewCount: 506,
  }),
  buildNewsItem({
    id: 15,
    type: 'cases',
    category: 'study',
    tag: '留学',
    title: '捷报！宁波客户留学签证两周获批',
    desc: '学校录取及财力证明准备充分，新西兰留学签证审理高效。',
    date: '2026-04-14',
    cover: require('@/assets/imgs/ysgj_004@2x.png'),
    viewCount: 457,
  }),
]

export function getNewsById(id) {
  const targetId = Number(id)
  return newsList.find((item) => item.id === targetId) || null
}

export function buildNewsDetailPath(id) {
  return `/news-detail/${id}`
}

export function buildHomeNewsColumns() {
  const iconMap = {
    biz: require('@/assets/imgs/ysgj_013@2x.png'),
    news: require('@/assets/imgs/ysgj_014@2x.png'),
    cases: require('@/assets/imgs/ysgj_015@2x.png'),
  }

  return newsTypeOptions.map((group) => {
    const items = newsList.filter((item) => item.type === group.value)
    const preview = items.find((item) => item.isHomePreview) || items[0]

    return {
      key: group.value,
      title: group.label,
      icon: iconMap[group.value],
      items: items.slice(0, 5),
      preview,
    }
  })
}

export const honorList = [
  { image: require('@/assets/imgs/ysgj_046@2x.png'), title: '营业执照' },
  { image: require('@/assets/imgs/ysgj_045@2x.png'), title: '新西兰移民持牌顾问牌照' },
  { image: require('@/assets/imgs/ysgj_047@2x.png'), title: '新西兰投资和移民协会会员' },
  { image: require('@/assets/imgs/ysgj_048@2x.png'), title: '移民持牌顾问牌照历史-2008年至今' },
]
